// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__xcPx2"};